console.log('load');
$(document).ready(() => {
    const ns = Esearcher.Ui.Notifier;
    const notifier = ns.getInstance();
    console.log('ready');
    $(document).on('click', '.applicant-contact-warning', async function () {
        const applicantId = $(this).attr('data-applicant-id');
        if (Number(applicantId) === 0) {
            return;
        }

        const baseUrl = '/applicant/status/{id}';
        const url = baseUrl.replace('{id}', applicantId);

        const response = await fetch(url);
        const data = await response.json();

        if (data.access === true) {
            return;
        }

        let type = '';
        switch (data.id) {
            case 2:
                type = ns.TYPE_WARNING;
                break;
            case 3:
                type = ns.TYPE_ERROR;
                break;
        }

        if (type.length > 0) {
            notifier.notify(data.long, type, NaN);
        }
    });
});
